<div fxLayout="row" class="item-badge is-timeline" fxLayoutAlign="center center">
    @if (project) {
        <div class="pr-5" fxLayout="row" fxLayoutAlign="center flex-start">
            @if (badge.competency.typeCompetency === 0) {
                <img
                    class="img-competency-timeline"
                    src="{{ imagesSvc.getUrlImageCompetency(badge.competency) }}"
                    [title]="badge.competency.name"
                />
            }
            @if (badge.competency.typeCompetency !== 0) {
                <img
                    class="img-competency-timeline"
                    src="{{ imagesSvc.getUrlImageDefaultMission() }}"
                    [title]="badge.competency.name"
                />
            }
            <div class="icon-line"></div>
        </div>
    }

    <div class="person-avatar pr-16" fxLayout="row" fxLayoutAlign="center flex-start">
        @if (project && project.entryPoint.showTimelineGrantor) {
            <img
                class="img-circle"
                [src]="getImagePerson(badge.userDeliver.username)"
                [title]="badge.userDeliver.username"
            />
        }
        @if (project && !project.entryPoint.showTimelineGrantor && badge.userReceive) {
            <img
                class="img-circle"
                [src]="getImagePerson(badge.userReceive.username)"
                [title]="badge.userReceive.username"
            />
        }
        @if (project && !project.entryPoint.showTimelineGrantor && badge.grantees.length > 0 && !badge.userReceive) {
            <img [src]="getImageGroup()" class="img-circle" />
        }
        <!-- <div *ngIf="project && (!project.entryPoint.showTimelineGrantor) && badge.grantees.length>0 && !badge.userReceive" class="img-circle" style="width: 50px; text-align: center;">
    <mat-icon>{{ getImageGroup() }}</mat-icon>
  </div> -->
    </div>

    <div fxFlex="1 1 0">
        <div fxLayout="row" fxLayoutAlign="space-between center" class="">
            <p class="m-0 badge-text">
                @if (project && project.entryPoint.showCompetencyTextTimeline == 1) {
                    {{ "home.badges.from" | translate }}
                    @if (badge.userDeliver && user) {
                        <a
                            [routerLink]="
                                badge.userDeliver.id === user.id
                                    ? ['/perfil']
                                    : ['/perfil/@' + badge.userDeliver.username]
                            "
                            style="cursor: pointer"
                            >{{ badge.userDeliver.name }}</a
                        >
                    }
                    {{ "home.badges.to" | translate }}
                }

                @if (project && project.entryPoint.showCompetencyTextTimeline == 2) {
                    @if (badge.userDeliver && user) {
                        <a
                            [routerLink]="
                                badge.userDeliver.id === user.id
                                    ? ['/perfil']
                                    : ['/perfil/@' + badge.userDeliver.username]
                            "
                            style="cursor: pointer"
                            >{{ badge.userDeliver.name }}</a
                        >
                    }
                    {{ "general.ha_reconocido_a" | translate }}
                }

                <!-- Receptor/es de la badge -->
                @if (badge.userReceive && user) {
                    <a
                        [routerLink]="
                            badge.userReceive.id === user.id ? ['/perfil'] : ['/perfil/@' + badge.userReceive.username]
                        "
                        style="cursor: pointer"
                        >{{ badge.userReceive.name }}</a
                    >
                }

                @if (badge.grantees && badge.grantees.length > 0 && badge.grantees.length <= 10 && !badge.userReceive) {
                    @for (grantee of badge.grantees; track grantee; let i = $index) {
                        @if (i > 0 && i < badge.grantees.length - 1) {
                            <span>, </span>
                        }
                        @if (i == badge.grantees.length - 1) {
                            <span> y </span>
                        }
                        <a
                            [routerLink]="grantee.id === user.id ? ['/perfil'] : ['/perfil/@' + grantee.username]"
                            style="cursor: pointer"
                            >{{ grantee.name }}</a
                        >
                    }
                }

                @if (badge.grantees && badge.grantees.length > 0 && badge.grantees.length > 10 && !badge.userReceive) {
                    <b>{{ badge.grantees.length }} {{ "timeline.users" | translate }}</b>
                }
                <!-- ------------------- -->

                @if (project && project.entryPoint.showCompetencyTextTimeline == 1) {
                    {{ "home.badges.for" | translate }} {{ badge.competency.name }}.
                }

                @if (project && project.entryPoint.showCompetencyTextTimeline == 2) {
                    {{ "general.in" | translate }} {{ textTipoCompetencia(badge.competency.typeCompetency) }}.
                }

                @if (project && project.entryPoint.showCompetencyTextTimeline == 3) {
                    ha recibido la medalla <b>{{ badge.competency.name }}</b> de
                    @if (badge.userDeliver && user) {
                        <a
                            [routerLink]="
                                badge.userDeliver.id === user.id
                                    ? ['/perfil']
                                    : ['/perfil/@' + badge.userDeliver.username]
                            "
                            style="cursor: pointer"
                            >{{ badge.userDeliver.name }}</a
                        >
                    }
                }
                @if (project && project.enabled_subject && badge.subject != null && badge.subject !== "") {
                    <p>{{ "general.for" | translate }} {{ badge.subject }}</p>
                }
            </p>
            <p class="badge-date m-0 ml-8" [title]="momentDateFormat(badge.fecha)">
                {{ momentDate(badge.fecha) }}
            </p>
        </div>
    </div>
</div>
